import { render, staticRenderFns } from "./EditSelectedClass.vue?vue&type=template&id=1ae9121b&scoped=true&"
import script from "./EditSelectedClass.vue?vue&type=script&lang=js&"
export * from "./EditSelectedClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae9121b",
  null
  
)

export default component.exports